import React from 'react'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'

const GridTitle = withStyles(theme => ({
  root: {
    padding: '14px 0',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(14),
  },
}))(({ classes, children }) => (
  <Grid item className={classes.root} xs={12} sm>
    {children}
  </Grid>
))

export default GridTitle


